import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { Alert } from "@material-ui/lab";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import FeeEditForm from "../../../clients/admin/fee/FeeEditForm";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../../styles/styledTabsForm";
import { StyledFeeDetailsWrapper } from "../../../fee/styledFee";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const FeeDetailsContainer = ({ match }) => {
  const { t } = useTranslation("clientsPage");
  const [fee, setFee] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/fees/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFee(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (!fee) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fee.length === 0) {
    return <Alert severity="warning">{t("details.fee.edit.form.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("details.fee.edit.title")} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton handler={() => {history.goBack();}} pt="20" pb="30" />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.fee.edit.form.paymentSystem")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.fee.edit.form.service")}
                  type="text"
                  value={getServiceNameWithNickname(fee.baseFee.service.name, fee.baseFee.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.fee.edit.form.paymentSystem")}
                  type="text"
                  value={fee.baseFee.paymentSystem.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.fee.edit.form.currency")}
                  type="text"
                  value={fee.baseFee.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.fee.edit.form.type")}
                  type="text"
                  value={fee.baseFee.type}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.fee.edit.form.fee")}
              </StyledBlockLabel>
              <FeeEditForm
                fee={fee}
                notification={notification}
                setNotification={setNotification}
                url="/api/fees/"
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default FeeDetailsContainer;